import React from "react";

export default function SQLServer_RTRIM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_RTRIM</h1>
      <p>This is the SQLServer_RTRIM component generated from the SQL JSON.</p>
    </div>
  );
}
